const DB_NAME = 'logosdb'
const STORAGE_NAME = 'logos'
const DB_VERSION = 1
let DB
export default {
  async getDb() {
    return new Promise((resolve, reject) => {
      if (DB) {
        return resolve(DB)
      }
      const indexedDB =
        window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB
      const request = indexedDB.open(DB_NAME, DB_VERSION)
      request.onerror = e => {
        console.log('Error opening db', e)
        reject('Error')
      }
      request.onsuccess = e => {
        DB = e.target.result
        resolve(DB)
      }
      request.onupgradeneeded = e => {
        let db = e.target.result
        db.createObjectStore(STORAGE_NAME)
      }
    })
  },
  async getLogos() {
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readonly')
      trans.oncomplete = () => {
        resolve(logos)
      }
      const store = trans.objectStore(STORAGE_NAME)
      const logos = []
      store.openCursor().onsuccess = e => {
        const cursor = e.target.result
        if (cursor) {
          logos.push(cursor.value)
          cursor.continue()
        }
      }
    })
  },
  async saveLogos(logos) {
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }
      let store = trans.objectStore(STORAGE_NAME)
      store.put(logos, 'logos')
    })
  },
}
